<template>
  <div class="mx-auto">
    <TitleWrapper
      :filter-option="false"
      title="SCHEDULE_SETTINGS"
      tooltip-title="SCHEDULE_SETTINGS"
      :display-breadcrumb="true"
    ></TitleWrapper>
    <div class="minHeightMainContent flex-col bg-primary-white mt-5 p-5">
      <div v-if="!loading">
        <ScheduleCheckbox
          v-for="(val, ind) in settingsArray"
          :key="ind"
          parent-module="schedule"
          class="mt-6"
          :title="ind"
          :modules-array="val"
          :table-head-array="tableHeadArray"
          @updateSettings="getSettings"
        />
      </div>
      <Loader v-else class="mt-28" :content="true" />
    </div>
  </div>
</template>

<script>
import TitleWrapper from '@components/TitleWrapper.vue'
import ScheduleCheckbox from '@src/components/Settings/attandance-settings/AttandanceCheckBoxForm.vue'
import Loader from '@components/BaseComponent/Loader.vue'
/* 3rd party Component */
import { mapActions, mapState } from 'vuex'
/**
 * @notes IMPORTANT NOTES
 * index ACTION FOR VIEW
 * create ACTION FOR Create
 * update ACTION FOR Edit
 * deactivate ACTION FOR delete
 * */

export default {
  components: {
    TitleWrapper,
    ScheduleCheckbox,
    Loader,
  },
  data: function () {
    return {
      settingsArray: [],
      tableHeadArray: ['Settings', 'View', 'Create', 'Edit', 'Delete'],
      loading: false,
    }
  },
  page: {
    title: 'System Settings | Schedule Settings',
    meta: [
      {
        name: 'description',
        content: 'Schedule Settings',
      },
    ],
  },
  computed: {
    ...mapState('layout', [
      'currentCampusScope',
      'currentSectionScope',
      'currentClassScope',
      'activeRole',
    ]),
  },
  watch: {
    currentCampusScope: {
      handler: function () {
        this.getSettings()
      },
      deep: true,
    },
    currentSectionScope: {
      handler: function (val) {
        this.getSettings()
      },
      deep: true,
    },
    currentClassScope: {
      handler() {
        this.getSettings()
      },
    },
    activeRole: {
      handler: function () {
        this.getSettings()
      },
      deep: true,
    },
  },

  async mounted() {
    this.getSettings()
  },

  methods: {
    async getSettings() {
      this.loading = true
      const [res, err] = await this.getSchedulePermissionSettings()
      this.settingsArray = res.data
      this.loading = false
    },
    ...mapActions('settings', ['getSchedulePermissionSettings']),
  },
}
</script>
